import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  BlockType,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box, Paragraph } from "theme-ui";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { EyecatcherType, layoutOptions } from "./types/prop-types";

/** Eyecatcher Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.ExtraSmall,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

export const Eyecatcher = primaryBlock<EyecatcherType>(
  blockConfig,
  ({
    tagline,
    header,
    description,
    image,
    SecondaryBlock,
    TertiaryBlock,
    layoutProps,
  }: EyecatcherType) => (
    <Box className="primary-eyecatcher-large-image-v1">
      <Box
        className={`header9_component ${
          layoutProps.imageSize !== "large" && "full-screen"
        }`}
      >
        <Box className="padding-global">
          <Box
            sx={{
              maxWidth:
                layoutProps.headerPlacement === "center" ? "48rem" : "80rem",
            }}
            className="container-large"
          >
            <Box className="padding-vertical padding-xxlarge max-width">
              <Box
                sx={{
                  gridTemplateColumns: `1fr${
                    layoutProps.headerPlacement !== "center" && " 1fr"
                  }`,
                }}
                className="header9_content-wrapper"
              >
                <Box
                  sx={{
                    order: layoutProps.headerPlacement === "right" ? 1 : -1,
                  }}
                  className="header9_content-left"
                >
                  {tagline && (
                    <Box className="tagline-margin">
                      <Variants.TagLine>{tagline}</Variants.TagLine>
                    </Box>
                  )}
                  <Variants.Heading as="h1">{header}</Variants.Heading>
                </Box>
                <Box className="header9_content-right">
                  <Paragraph>{description}</Paragraph>
                  <Box className="margin-top margin-medium">
                    {renderSecondaryBlock(SecondaryBlock)}
                    {renderTertiaryBlock(TertiaryBlock)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        {image.url && (
          <Box className="header9_image-wrapper">
            <Box className="header9_background-image-wrapper">
              {layoutProps.imageSize === "large" ? (
                <Variants.Image
                  src={image.url}
                  alt={image.alt}
                  className="large-image"
                />
              ) : (
                <Variants.ImageNoRadius // TODO: border radius for top left and right only
                  src={image.url}
                  alt={image.alt}
                  className="header9_background-image"
                />
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
);

Eyecatcher.defaultProps = getDefaultProps<EyecatcherType>(defaults);

export const Element: KameleonElement = {
  component: Eyecatcher,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
